<template>
  <v-dialog v-model="dialVal" persistent max-width="371px" max-height="658px">
    <v-card elevation="0" class="form-modal">
      <v-card-title>
        <span class="header3">Invitar usuario</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row
            ><v-col cols="12">
              <span class="label">Nombre:</span>
              <v-text-field
                v-model="name"
                class="input-text body-text"
                dense
                flat
                solo
                outlined
                :rules="[rules.requiredName]"
                hide-details="auto"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="12">
              <span class="label">Correo electrónico:</span>
              <v-text-field
                v-model="email"
                class="input-text body-text"
                dense
                flat
                solo
                outlined
                :rules="[rules.requiredEmail, rules.email]"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="v-btn--primary"
          :disabled="!validation"
          @click="
            () => {
              inviteUser();
              dialVal = false;
            }
          "
          >Invitar</v-btn
        >
        <v-btn
          class="v-btn--secondary"
          @click="
            () => {
              dialVal = false;
              cancelForm();
            }
          "
        >
          Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      rules: {
        confirmPass: () => {
          return this.password === this.passwordVal || "Las contraseñas no coinciden.";
        },
        requiredName: (value) => !!value || "Es necesario añadir un nombre.",
        requiredEmail: (value) => !!value || "Es necesario añadir un email.",
        requiredPass: (value) =>
          !!value || "Es necesario añadir una contraseña.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "El email no es válido.";
        },
      },
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    cancelForm() {
      this.name = "";
      this.email = "";
    },
    inviteUser() {
      /*TODO: add logic for this method*/
    }
  },
  computed: {
    dialVal: {
      get() {
        return this.active;
      },
      set() {
        this.$emit("toggle");
      },
    },
    validation () {
      const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const name_val =
        this.name.split("").filter((e) => e !== "").length > 0 &&
        this.name.length > 0;
      const email_val =
        this.email.split("").filter((e) => e !== "").length > 0 &&
        this.email.length > 0 && pattern.test(this.email);
      return name_val && email_val;
    },
  }
}
</script>